interface Props {
  children: React.ReactNode;
}

export const DrawerWrapper: React.FC<Props> = ({ children }) => {
  return (
    <div className="bg-grayscale-base h-[100vh-64px] w-[224px] box-border p-[12px]">
      {children}
    </div>
  );
};
